import { request } from './client';
import type { PlayerNote } from './types';

// Every agent key may write. Middleware takes the author from the key; bigquery-service lets the
// author edit and the author or an admin delete. Notes are read back with the whales rows.
export const createNote = async (key: string, playerUuid: string, body: string): Promise<PlayerNote> =>
  (await request<{ note: PlayerNote }>('/api/player-notes', { key, method: 'POST', body: { playerUuid, body } })).note;

export const updateNote = async (key: string, id: number, body: string): Promise<PlayerNote> =>
  (await request<{ note: PlayerNote }>(`/api/player-notes/${id}`, { key, method: 'PATCH', body: { body } })).note;

export const deleteNote = async (key: string, id: number): Promise<void> => {
  await request<{ ok: true }>(`/api/player-notes/${id}`, { key, method: 'DELETE' });
};
